<div class="sort-container">
  <div class="sort-header">
    <mat-label>Document Sorting</mat-label>
    <mat-icon class="help-icon"
      matTooltip="Drag a row to reorder, then choose ↑ (asc) or ↓ (desc)."
      matTooltipPosition="right">
      help_outline
    </mat-icon>
  </div>
  <div cdkDropList class="sort-list" (cdkDropListDropped)="drop($event)">
    @for (criteria of sortCriteria; track criteria) {
      <div class="sort-box" cdkDrag>
        <div class="drag-indicator">
          <mat-icon class="drag-handle">drag_indicator</mat-icon>
        </div>
        <div class="field-name" [matTooltip]="getSortByLabel(criteria.field)">
          {{ getSortByLabel(criteria.field) }}
        </div>
        <div class="direction-controls">
          <button class="direction-btn"
            [class.active]="criteria.direction === sorting.DirectionEnum.ASC.value"
            (click)="setDirection(criteria, sorting.DirectionEnum.ASC.value)"
            matTooltip="Sort ascending">
            <mat-icon>arrow_upward</mat-icon>
          </button>
          <button class="direction-btn"
            [class.active]="criteria.direction === sorting.DirectionEnum.DESC.value"
            (click)="setDirection(criteria, sorting.DirectionEnum.DESC.value)"
            matTooltip="Sort descending">
            <mat-icon>arrow_downward</mat-icon>
          </button>
        </div>
      </div>
    }
  </div>
</div>